const currency = 'BRL';
const locale = 'pt-BR';

const _formattedNumber = (value, style = 'percent', minimumFractionDigits = 2) => {
  if(!value || isNaN(value) || value === Infinity) {
    value = 0;
  }

  return new Intl.NumberFormat(locale, { style, currency, minimumFractionDigits }).format(value);
}

export default (total = 0, value = 0) => {
  return _formattedNumber(value / total);
}
